import { BlueprintFamilyExampleImage, toBlueprintFamilyExampleImageInput } from '../../api/blueprintFamilies/exampleImages'

/**
 * The example screenshot part of a blueprint family write body.
 *
 * Only the two stored fields go back; `gameId`, `gameNames`, `eventName`, `eventTypeId` and
 * `screenshotIndex` are derived by the BE on every read. List order is display order.
 *
 * Neither field may be `null`, and omitting one means an empty list, so an empty selection is left
 * out rather than sent as `[]`. On an update that also clears what was stored, and it keeps the body
 * of a blueprint nobody has curated identical to what it was before these fields existed.
 */
export const exampleImagesBody = (images?: BlueprintFamilyExampleImage[]): { glossaryImages?: { url: string; eventId: string }[] } =>
  images && images.length > 0 ? { glossaryImages: images.map(toBlueprintFamilyExampleImageInput) } : {}

/**
 * The accepted event type part of a blueprint family write body.
 *
 * An empty list means no restriction, which is also what omitting the field means, so a family
 * that accepts everything says nothing about its types.
 *
 * There is no `allowedEventTypeIds` on the read side: the accepted types come back as `eventTypes`.
 */
export const acceptedEventTypesBody = (eventTypeIds?: string[]): { allowedEventTypeIds?: string[] } =>
  eventTypeIds && eventTypeIds.length > 0 ? { allowedEventTypeIds: eventTypeIds } : {}
